import React from 'react';

type PortableHeaterIconProps = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
};

/** A freestanding patio heater with a reflector shade, heating bar and base. */
const PortableHeaterIcon: React.FC<PortableHeaterIconProps> = ({
  size = 24,
  strokeWidth = 1.5,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M3 8c1.5-3 4.5-4.5 9-4.5S19.5 5 21 8H3Z" />
    <path d="M6 10.5h12M12 10.5V20M6.5 13 6 15M17.5 13l.5 2" />
    <path d="M9 20h6l1.5 2h-9L9 20Z" />
  </svg>
);

export default PortableHeaterIcon;
